// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/(auth)/admin/integrations": [8,[2]],
		"/(auth)/admin/poster-builder": [9,[2]],
		"/(auth)/admin/settings": [10,[2]],
		"/(auth)/admin/theme": [11,[2]],
		"/(auth)/admin/users": [12,[2]],
		"/check-email": [71],
		"/dashboardnew": [72],
		"/(auth)/dashboard": [13,[2]],
		"/(auth)/dashboard/explore-next": [15,[2]],
		"/(auth)/dashboard/explore": [14,[2]],
		"/(auth)/dashboard/innstillinger": [16,[2]],
		"/(auth)/dashboard/screens": [17,[2]],
		"/(auth)/dashboard/screens/[id]/play": [18,[2]],
		"/link-service": [73],
		"/link-service/[id]": [74],
		"/login": [75],
		"/plakat": [76,[5]],
		"/plakat/innstillinger": [77,[5]],
		"/plakat/[id]": [78,[5]],
		"/(auth)/plakat/[id]/rediger": [19,[2]],
		"/(auth)/priser": [20,[2]],
		"/(auth)/priser/innstillinger": [21,[2]],
		"/(auth)/product/[id]/rediger": [22,[2]],
		"/(auth)/produkt-cms": [23,[2]],
		"/(auth)/produkt-cms/ai/settings": [24,[2]],
		"/(auth)/produkt-cms/diagnostics": [25,[2]],
		"/(auth)/produkt-cms/editor": [26,[2]],
		"/(auth)/produkt-cms/group-trees": [27,[2]],
		"/(auth)/produkt-cms/import": [28,[2]],
		"/(auth)/produkt-cms/import/settings": [29,[2]],
		"/(auth)/produkt-cms/new": [30,[2]],
		"/(auth)/produkt-cms/settings": [31,[2]],
		"/(auth)/produkt-cms/settings/group-tree-attributes": [32,[2]],
		"/produkt/lokasjon": [79,[6]],
		"/produkt/lokasjon/innstillinger": [80,[6]],
		"/register": [81],
		"/register/success": [82],
		"/(auth)/seo-cms": [33,[2]],
		"/(auth)/seo-cms/debug": [34,[2]],
		"/(auth)/seo-cms/editor": [35,[2]],
		"/(auth)/seo-cms/innstillinger": [36,[2]],
		"/(auth)/settings": [37,[2]],
		"/(auth)/superadmin": [38,[2,3]],
		"/(auth)/superadmin/api-keys": [39,[2,3]],
		"/(auth)/superadmin/brukere": [40,[2,3]],
		"/(auth)/superadmin/firmaer": [41,[2,3]],
		"/(auth)/superadmin/firmaer/[id]": [42,[2,3]],
		"/(auth)/superadmin/firmaer/[id]/brukere": [43,[2,3]],
		"/(auth)/superadmin/home": [44,[2,3]],
		"/(auth)/superadmin/logs": [45,[2,3]],
		"/(auth)/superadmin/logs/viewer": [46,[2,3]],
		"/(auth)/superadmin/logs/[serviceId]": [47,[2,3]],
		"/(auth)/superadmin/maler": [48,[2,3]],
		"/(auth)/superadmin/services": [49,[2,3]],
		"/(auth)/superadmin/services/[serviceId]/support": [50,[2,3]],
		"/(auth)/superadmin/sql": [51,[2,3]],
		"/(auth)/superadmin/sql/[serviceId]": [52,[2,3]],
		"/(auth)/wms": [53,[2,4]],
		"/(auth)/wms/etiketter": [54,[2,4]],
		"/(auth)/wms/feedback-scenarios": [55,[2,4]],
		"/(auth)/wms/flytt": [56,[2,4]],
		"/(auth)/wms/lokasjoner": [57,[2,4]],
		"/(auth)/wms/lokasjoner/bygger": [58,[2,4]],
		"/(auth)/wms/mock": [59,[2,4]],
		"/(auth)/wms/mottak": [60,[2,4]],
		"/(auth)/wms/oppgaver": [61,[2,4]],
		"/(auth)/wms/plukklister": [64,[2,4]],
		"/(auth)/wms/plukklister/henteordre/[orderHeaderId]": [65,[2,4]],
		"/(auth)/wms/plukklister/plukk/[orderHeaderId]": [66,[2,4]],
		"/(auth)/wms/plukk": [62,[2,4]],
		"/(auth)/wms/plukk/[orderHeaderId]": [63,[2,4]],
		"/(auth)/wms/settings": [67,[2,4]],
		"/(auth)/wms/telling": [68,[2,4]],
		"/(auth)/wms/telling/planer": [69,[2,4]],
		"/(auth)/wms/varerobot": [70,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);